<div class="grid-toolbar">
  <div class="grid-toolbar-container">
    <div class="grid-toolbar-body">
      <ul class="toolbar-list">
        <li class="toolbar-list-item" (click)="refresh()">
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-refresh"></i>
            </span>
            <span class="list-item-title">{{ "refresh" | translate }}</span>
          </div>
        </li>
        <li class="toolbar-list-item" (click)="templateOpen()">
          <div class="list-button">
            <span class="list-icon">
              <img
                style="width: 14px; height: 14px"
                src="assets/icons/design.png"
                alt="design-button"
              />
            </span>
            <span class="list-item-title">{{
              "save_design_or_load" | translate
            }}</span>
          </div>
        </li>
        <li class="toolbar-list-item" (click)="fieldsOpen()">
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-tasks" aria-hidden="true"></i>
            </span>
            <span class="list-item-title">{{ "field_list" | translate }}</span>
          </div>
        </li>
        <li class="toolbar-list-item">
          <div class="list-button">
            <span class="list-icon">
              <i class="fal fa-upload" aria-hidden="true"></i>
            </span>
            <span class="list-item-title">{{ "export" | translate }}</span>
            <div dropdown container="body" class="list-dropdown">
              <button
                dropdownToggle
                type="button"
                class="btn btn-sm list-dropdown-button"
              >
                <i class="fal fa-angle-down" aria-hidden="true"></i>
              </button>
              <ul
                class="dropdown-menu toolbar-dropdown-menu"
                role="menu"
                *dropdownMenu
              >
                <li role="menuitem" (click)="exportAs('PDF')">
                  <span class="list-head"></span>
                  <a class="dropdown-item">
                    <i class="fal fa-file-pdf-o" aria-hidden="true"></i>
                    {{ "pdf" | translate }}</a
                  >
                </li>
                <li role="menuitem" (click)="exportAs('XLSX')">
                  <span class="list-head"></span>
                  <a class="dropdown-item">
                    <i class="fal fa-file-excel-o" aria-hidden="true"></i>
                    {{ "excel" | translate }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="col-md-12 col-sm-12 form-header" *ngIf="gridHeaderName">
  <div class="left-group">
    <span class="title">{{ gridHeaderName }}</span>
    <div class="form-header-alert">
      <kl-alert
        [show]="alertShow"
        [message]="alertMessage"
        [type]="alertType"
        (onClose)="closeAlert()"
      ></kl-alert>
    </div>
  </div>
</div>
